import script from "./Banners.vue?vue&type=script&setup=true&lang=js"
export * from "./Banners.vue?vue&type=script&setup=true&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=6a5b2c02&scoped=true&lang=css"
import "./Banners.vue?vue&type=style&index=1&id=6a5b2c02&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5b2c02"]])

export default __exports__